<template>
  <div class="jin-index-warp">
    <div class="jin-index-title">
      <h1 class="wow fadeInDown">{{ info.title }}</h1>
      <p>{{ info.subTitle }}</p>
    </div>
    <div class="jin-index-search">
      <el-input v-model="name" :placeholder="info.input" @input="SET_SEARCH_KEY" @keyup.enter.native="onSearch" />
      <!-- <p>{{ info.input }}</p> -->
      <span @click="onSearch">
        <Icon name="search" />
      </span>
    </div>
    <div v-if="isPc" class="jin-index-desc wow fadeInUp" data-wow-delay="0.8s">
      <p v-for="(item, i) in info.desc" :key="i">{{ item }}</p>
    </div>
  </div>
</template>

<script>
import { info } from './option'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    isPc: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      info,
      name: ''
    }
  },
  computed: {
    ...mapGetters([
      'key'
    ])
  },
  watch: {
    name: {
      handler(n) {
        this.SET_SEARCH_KEY(n)
      }
    }
  },
  methods: {
    ...mapMutations('position', ['SET_SEARCH_KEY', 'RESET_LIST']),
    onSearch() {
      if (!this.name.trim()) return this.Toast('请输入关键字再搜索')
      this.RESET_LIST()
      this.$router.push('/search')
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-index {
    &-warp {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &-title {
      h1 {
        // color: #3d4351;
        color: #fff;
      }

      p {
        text-align: center;
        // color: #787b8a;
        color: #fff;
        position: relative;

        &::before,
        &::after {
          content: '';
          display: block;
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        &::before {
          background-image: url('~@/assets/index/left.png');
        }

        &::after {
          background-image: url('~@/assets/index/right.png');
        }
      }
    }

    &-search {
      cursor: pointer;
      position: relative;

      /deep/ .el-input,
      p {
        // background: #fff;
        color: #a0a4b7;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;

        input {
          height: 100%;
          border: none;
        }
      }

      p {
        display: flex;
        align-items: center;
      }

      span {
        cursor: pointer;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: linear-gradient(180deg, #4777f4 0%, #4777f4 100%);
        border-radius: 50%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-desc {
      p {
        // color: #787b8a;
        color: #fff;
        text-indent: 2em;
      }
    }
  }
}

</style>
